import React from 'react'

export function Contact() {
  return (
    <div>
      <h1>Estamos en contact</h1>
    </div>
  )
}
